import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=1e4d7a7b"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"
import style0 from "./Chat.vue?vue&type=style&index=0&id=1e4d7a7b&prod&lang=scss"
import style1 from "./Chat.vue?vue&type=style&index=1&id=1e4d7a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports